import React from 'react';
import styled from 'styled-components';
import Radios from 'gatsby-theme-core/src/components/form-elements/radio/multi';
import Wrapper from './wrapper';
import Label from './label';

const Radio = ({
  className,
  name,
  label = null,
  required = false,
  values = [],
  onChange,
  value,
}) => (
  // Radios contains labels, so make this a div
  <Wrapper $singleColumn={!label} as="div">
    {label && <Label required={required}>{label}</Label>}
    <Radios
      className={className}
      name={name}
      value={value}
      onChange={onChange}
      options={values}
      required={required}
    />
  </Wrapper>
);

export default styled(Radio)``;
